<template>
  <div class="description-edit">
    <div class="text-right">
      <b-button @click="isEditing = !isEditing" type="button" variant="primary"
        >編輯</b-button
      >
    </div>
    <b-form>
      <b-form-group
        label="標題"
        label-for="one-description-create-title"
        class="required-icon-star"
      >
        <b-form-input
          id="one-description-create-title"
          type="text"
          :state="verifyTitle"
          :title="'請輸入值'"
          :disabled="!isEditing"
          :value="$store.getters.oneDescription.title"
          @input="$store.commit('oneDescriptionTitle', $event)"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="發布日期" class="required-icon-star">
        <b-form-datepicker
          placeholder="請選擇發布日期"
          :state="verifyDate"
          :title="'請輸入值'"
          :disabled="!isEditing"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          }"
          :value="$store.getters.oneDescription.released_at"
          @input="$store.commit('oneDescriptionReleasedAt', $event)"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-group label="內容" label-for="one-description-create-content">
        <editor
          :isReadOnly="!isEditing"
          :value="$store.getters.oneDescription.content"
          @input="$store.commit('oneDescriptionContent', $event)"
        ></editor>
      </b-form-group>
    </b-form>
    <div class="text-right">
      <b-button
        class="mr-3"
        type="button"
        variant="primary"
        @click="verifyForm"
        :disabled="!isEditing"
        >修改</b-button
      >
      <b-button
        class="mr-3"
        type="button"
        variant="dark"
        :disabled="!isEditing"
        @click="$router.push({ name: 'WebsiteDescriptions' })"
        >取消</b-button
      >
    </div>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
import editor from "@/components/Editor.vue";
export default {
  name: "DescriptionEdit",
  mixins: [mixinsVerify],
  components: {
    editor
  },
  data() {
    return {
      verifyTitle: null,
      verifyDate: null,
      isEditing: false
    };
  },
  methods: {
    verifyForm() {
      this.verifyTitle = this.hasValue(this.$store.getters.oneDescription.title);
      this.verifyDate = this.hasValue(
        this.$store.getters.oneDescription.released_at
      );
      if (this.verifyTitle === false || this.verifyDate === false) return;
      else this.submit();
    },
    async submit() {
      //from YYYY-MM-DD format to YYYY/MM/DD
      let regex = /-/gi;
      const formatDate = this.$store.getters.oneDescription["released_at"].replace(
        regex,
        "/"
      );
      const postData = {
        title: this.$store.getters.oneDescription.title,
        content: this.$store.getters.oneDescription.content,
        released_at: formatDate
      };
      await this.$store.dispatch("updateOneDescription", postData)
      this.$router.push({ name: "WebsiteDescriptions" });
    }
  }
};
</script>

<style lang="scss" scoped>
.description-edit {
  padding: 1rem;
}
</style>
